'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Manager = require('./Manager');

Object.defineProperty(exports, 'Manager', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Manager).default;
  }
});

var _Teacher = require('./Teacher');

Object.defineProperty(exports, 'Teacher', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Teacher).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }